import { render } from "./CoursePanelNavigation.vue?vue&type=template&id=1ac6e191&scoped=true"
import script from "./CoursePanelNavigation.vue?vue&type=script&lang=js"
export * from "./CoursePanelNavigation.vue?vue&type=script&lang=js"

import "./CoursePanelNavigation.vue?vue&type=style&index=0&id=1ac6e191&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac6e191"]])

export default __exports__